import { Component, Vue } from 'vue-property-decorator';
import authenticator from '@/store/authentication';
import { UserProfile as Profile } from '@/types';
import CardComponent from '@/components/CardComponent';
import appStore from '@/store/app';

@Component({
    components: { CardComponent },
  })
export default class UserProfile extends Vue {

    get loading(): boolean {
        return appStore.isLoading;
    }

    get user(): Profile {
        return authenticator.userProfile;
    }

    private async mounted() {
        await appStore.activateMenuById({rootId: 400, subMenuId: 402 });
    }

    private cancel(): void {
        this.$router.go(-1);
    }
}